import React, { Component, Fragment } from "react";
import "react-day-picker/lib/style.css";
import { Col, Table, Container, Row } from "react-bootstrap";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import DodajStrucnoUsavrsavanje from "../../components/StrucnaUsavrsavanja/DodajStrucnoUsavrsavanje";
import UnosObavijesti from "../../components/StrucnaUsavrsavanja/UnosObavijesti";
import "../../components/StrucnaUsavrsavanja/StrucnaUsavrsavanja.css";
import Badge from "react-bootstrap/Badge";
import axiosInstance from "../../api/utils/axiosInstance";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import {
  DeleteOutlined,
  EditOutlined,
  PaperClipOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import Modal from "../../components/UI/Modal/Modal";

import ReactToPrint from "react-to-print";
import ObligationDetails from "./ObligationDetails";
import { toast } from "react-toastify";

class PregledStrucnogUsavrsavanja extends Component {
  constructor(props) {
    super(props);
    this.componentRef = [];
  }

  state = {
    isListLoading: true,
    dodavanjeModal: false,
    obavijestModal: false,
    brisanjeEdukacijeModal: false,
    isLoading: false,
    idStrUsv: null,
    rbr: null,
    vrstaAktivnosti: null,
    strucnaUsavrsavanja: [],
    susvSintetika: [],
    susvAnalitikaList: [],

    formData: {
      idStrUsv: "",
      rbr: "",
      godina: null,
      organizator: "",
      vrAktivnosti: null,
      nazAktivnosti: "",
      datPoc: null,
      datZav: null,
      podrucje: "",
      oznPolEdu: null,
      revSati: 0,
      revBodovi: 0,
      racSati: 0,
      racBodovi: 0,
      ostSati: 0,
      ostBodovi: 0,
      satiPodrucjeA: 0,
      bodoviPodrucjeA: 0,
      brSati: 0,

      brBodova: 0,
    },
    unosObavijestiData: {
      napomena: "",
      selectedFiles: [],
      absenceStart:"",
      absenceEnd:"",
    },
    obrazacData: {
      selectedFile: [],
    },
    obavijesti: [],
    dropdownVrAkt: [],
    dropdownUlSudionika: [],
    error: false,
    errorSusvSin: false,
    revizorId: null,
    isEdit: false,
    datPocStrUsv: null,
    datZavStrUsv: null,
    revizorAktivnost: null,
  };

  componentDidMount() {
    this.getVrsteAktivnosti();
    this.getUlogeSudionika();
    this.getRevizor();
  }

  async getRevizor() {
    try {
      const res = await axiosInstance.get(`/strucno-usavrsavanje/revizor?idOsobe=${this.props.match.params.idOsobe}`);
      this.setState({
        strucnaUsavrsavanja: res.data[0].strucnoUsavrsavanje,
        revizorAktivnost: res.data[0].osoba.oznAkt,
        isListLoading: false,
      },
      () => {
        this.state.strucnaUsavrsavanja.map((strUsv) => {
          if (strUsv.sts === 1) {
            this.setState({
              idStrUsv: strUsv.idStrUsv,
              susvAnalitikaList: strUsv.sekcijaObrasca.map((susvAnalitikaList) => susvAnalitikaList.susvAnalitikaList),
              susvSintetika: strUsv.sekcijaObrasca.map((susvSintetika) => susvSintetika.susvSintetika),
            });
          } else {
            this.setState({
              idStrUsv: strUsv.idStrUsv
            });
          }
        });
      });
    } catch (e) {
      throw e;
    } finally {
      this.setState({isListLoading: false});
    }
  }

  submitHandler = (e) => {
    e.preventDefault();

    const idStrUsv = this.state.idStrUsv;
    const rbr = this.state.rbr;
    const isEdit = this.state.isEdit;

    const susvAnalitika = {
      idStrUsv: idStrUsv,
      godina: moment(this.state.formData.datPoc, "DD.MM.YYYY").year(),
      organizator: this.state.formData.organizator,
      vrAktivnosti: this.state.formData.vrAktivnosti,
      nazAktivnosti: this.state.formData.nazAktivnosti,
      datPoc: this.state.formData.datPoc,
      datZav: this.state.formData.datZav,
      podrucje: this.state.formData.podrucje,
      oznPolEdu: this.state.formData.oznPolEdu,
      revSati: this.state.formData.revSati,
      revBodovi: this.state.formData.revBodovi,
      racSati: this.state.formData.racSati,
      racBodovi: this.state.formData.racBodovi,
      ostSati: this.state.formData.ostSati,
      ostBodovi: this.state.formData.ostBodovi,
      satiPodrucjeA: this.state.formData.satiPodrucjeA,
      bodoviPodrucjeA: this.state.formData.bodoviPodrucjeA,
      brSati: this.state.formData.brSati,
      brBodova: this.state.formData.brBodova,
    };

    const { datPoc, datZav, organizator, oznPolEdu, podrucje, nazAktivnosti, revSati, revBodovi, racSati, racBodovi, ostSati, ostBodovi} =
      this.state.formData;

    const isRevSatiEmpty = !revSati ? (revSati === 0 ? false : true) : false;
    const isRevBodoviEmpty = !revBodovi ? (revBodovi === 0 ? false : true) : false;

    const isRacSatiEmpty = !racSati ? (racSati === 0 ? false : true) : false;
    const isRacBodoviEmpty = !racBodovi ? (racBodovi === 0 ? false : true) : false;

    const isOstSatiEmpty = !ostSati ? (ostSati === 0 ? false : true) : false;
    const isOstBodoviEmpty = !ostBodovi ? (ostBodovi === 0 ? false : true) : false;

    if (
      !datPoc ||
      !datZav ||
      !organizator ||
      !oznPolEdu ||
      !podrucje ||
      !nazAktivnosti || 
      isRevSatiEmpty=== true ||
      isRevBodoviEmpty=== true ||
      isRacSatiEmpty=== true ||
      isRacBodoviEmpty=== true ||
      isOstSatiEmpty=== true ||
      isOstBodoviEmpty=== true
    ) {
      this.setState({ error: true });
      this.props.formSubmitError(true, "Popunite obavezna polja!");

      return;
    }
   
    if(nazAktivnosti.length > 200 || organizator.length > 200 || podrucje.length > 200){
      this.setState({error: true});
      this.props.formSubmitError(true,"Maksimalan broj znakova pri unosu je 200")

      return;
    }

    if (
      moment(datPoc, "DD.MM.YYYY").format("YYYY-MM-DD") <
        moment(this.state.datPocStrUsv).format("YYYY-MM-DD") ||
      moment(datPoc, "DD.MM.YYYY").format("YYYY-MM-DD") >
        moment(this.state.datZavStrUsv).format("YYYY-MM-DD")
    ) {
      this.setState({ error: true });

      this.props.formSubmitError(
        true,
        "Datum početka mora biti unutar intervala trogodišnjeg ciklusa praćenja stručnog usavršavanja: " +
          moment(this.state.datPocStrUsv).format("DD.MM.YYYY") +
          " - " +
          moment(this.state.datPocStrUsv).add(3, "years").subtract(1,"day").calendar()
      );

      return;
    }

    if (moment(datPoc, "DD.MM.YYYY") > moment(datZav, "DD.MM.YYYY")) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "Datum početka stručnog usavršavanja ne smije biti veći od datuma završetka!"
        );
      });
      return;
    }

    const daysOfEdu = moment(datZav, "DD.MM.YYYY").diff(moment(datPoc, "DD.MM.YYYY"),"days") + 1;
    const maxPerDay = 8;
    const minPerDay = 0.5;
    const maxForThisEdu = daysOfEdu * maxPerDay;
    const minForThisEdu = daysOfEdu * minPerDay;
    const totalH = revSati + racSati + ostSati;
    const totalP = revBodovi + racBodovi + ostBodovi;

    if((totalH > maxForThisEdu) || (totalP > maxForThisEdu) || (totalH < minForThisEdu) || (totalP < minForThisEdu)){
      this.setState({error:true});
      this.props.formSubmitError(true, `Maksimalan broj bodova/sati koji se može ostvariti u jednom danu je ${maxPerDay}, dok je minimalan ${minPerDay}`);

      return;
    }

    this.setState({ error: false, dodavanjeModal: false }, () => {
      if (isEdit) {
        this.updateAnalitika(rbr, susvAnalitika);
      } else {
        this.saveAnalitika(susvAnalitika, idStrUsv);
      }
    });
  };

  saveAnalitika = (susvAnalitika, idStrUsv) => {
    this.setState({ isLoading: true }, () => {
      const obrazac = this.state.obrazacData.selectedFile;
      try {
        axiosInstance
          .post(
            `/strucno-usavrsavanje/analitika?idStrUsv=${idStrUsv}`,
            susvAnalitika
          )
          .then((res) => {
            let rbr = res.data.rbr;
            this.setState(
              {
                vrstaAktivnosti: susvAnalitika.vrAktivnosti,
                formData: {
                  idStrUsv: "",
                  rbr: "",
                  godina: null,
                  organizator: "",
                  vrAktivnosti: null,
                  nazAktivnosti: "",
                  datPoc: null,
                  datZav: null,
                  podrucje: "",
                  oznPolEdu: null,

                  brBodova: 0,
                  revSati: 0,
                  revBodovi: 0,
                  racSati: 0,
                  racBodovi: 0,
                  ostSati: 0,
                  ostBodovi: 0,
                  satiPodrucjeA: 0,
                  bodoviPodrucjeA: 0,
                  brSati: 0,
                },
                susvAnalitikaList: res.data,
              },
              () => {
                this.saveObrazac(idStrUsv, obrazac, rbr, false);
                this.getRevizor();
                this.props.formSubmitSuccess(
                  false,
                  "Podaci o stručnom usavršavanju uspješno upisani."
                );
              }
            );
          });
      } catch (e) {
        this.props.formSubmitError(
          true,
          e.response.data.message || "Nešto je pošlo po krivu!"
        );
      } finally {
        this.setState({ isLoading: false });
      }
    });
  };

  saveObrazac = async (idStrUsv, obrazac, rbr, isEdit) => {
    if (obrazac.length > 0) {
      obrazac.map(async (element) => {
        const formData = new FormData();

        formData.append("obrazac", element.file);
        formData.append("idStrUsv", idStrUsv);
        formData.append("rbr", rbr);
        formData.append("isEdit", isEdit);

        await axiosInstance.post(
          "/strucno-usavrsavanje/upload/obrazac",
          formData
        );
      });
    }
    this.setState({
      obrazacData: {
        selectedFile: [],
      },
    });
  };

  updateAnalitika = (rbr, susvAnalitika) => {
    this.setState({ isLoading: true }, async () => {
      const obrazac = this.state.obrazacData.selectedFile;
      const idStrUsv = susvAnalitika.idStrUsv;
      const vrAktivnosti = susvAnalitika.vrAktivnosti;

      try {
        await axiosInstance.patch(
          `/strucno-usavrsavanje/analitika?rbr=${rbr}&idStrUsv=${idStrUsv}&vrAktivnosti=${vrAktivnosti}`,
          susvAnalitika
        );

        this.saveObrazac(idStrUsv, obrazac, rbr, true);
        this.getRevizor();

        this.props.formSubmitSuccess(
          false,
          "Podaci o stručnom usavršavanju uspješno ažurirani."
        );
      } catch (e) {
        this.props.formSubmitError(
          true,
          e.response.data.message || "Nešto je pošlo po krivu!"
        );
      } finally {
        this.setState({ isLoading: false });
      }
    });
  };

  openModalAzuriranje = (e, susvAnalitika) => {
    e.preventDefault();

    const { idStrUsv } = susvAnalitika;

    const findStrUsvDates = this.state.strucnaUsavrsavanja.find(
      (element) => element.idStrUsv === idStrUsv
    );

    const { datPoc, datZav } = findStrUsvDates;

    const redniBroj = susvAnalitika.rbr;

    this.setState({
      formData: {
        ...susvAnalitika,
        bodoviPodrucjeA: susvAnalitika.bodoviPodruceA,
      },
      idStrUsv,
      rbr: redniBroj,
      isEdit: true,
      dodavanjeModal: true,
      datPocStrUsv: datPoc,
      datZavStrUsv: datZav,
    });
  };

  /***************** MODALI ******************/
  openModalDodavanje(e, vrAktivnosti, idStrucnog, pocStrucnog, zavStrucnog) {
    e.preventDefault();

    this.setState({
      idStrUsv: idStrucnog,
      datPocStrUsv: pocStrucnog,
      datZavStrUsv: zavStrucnog,
      vrstaAktivnosti: vrAktivnosti,
      formData: {
        vrAktivnosti: vrAktivnosti,
        idStrUsv: "",
        rbr: "",
        godina: null,
        organizator: "",
        nazAktivnosti: "",
        datPoc: null,
        datZav: null,
        podrucje: "",
        oznPolEdu: null,
        revSati: 0,
        revBodovi: 0,
        racSati: 0,
        racBodovi: 0,
        ostSati: 0,
        ostBodovi: 0,
        satiPodrucjeA: 0,
        bodoviPodrucjeA: 0,
        brSati: 0,
        brBodova: "",
      },
      isEdit: false,
      dodavanjeModal: true,
    });
  }

  hideModalDodavanje = () => {
    this.setState({
      dodavanjeModal: false,
      error: false,
      formData: {
        idStrUsv: "",
        rbr: "",
        godina: null,
        organizator: "",
        vrAktivnosti: null,
        nazAktivnosti: "",
        datPoc: null,
        datZav: null,
        podrucje: "",
        oznPolEdu: null,
        revSati: null,
        revBodovi: "",
        racSati: null,
        racBodovi: "",
        ostSati: null,
        ostBodovi: "",
        satiPodrucjeA: "",
        bodoviPodrucjeA: "",
        brSati: "",
        brBodova: "",
      },
      datPocStrUsv: null,
      datZavStrUsv: null,

      obrazacData: {
        selectedFile: [],
      },
    });
  };

  openModalObavijest = (e, idStrUsv, datPoc, datZav) => {
    e.preventDefault();
    this.setState(
      {
        idStrUsv,
        obavijestModal: true,
        datPocStrUsv: datPoc,
        datZavStrUsv: datZav,
      },
      () => {
        this.getObavijesti(this.state.idStrUsv);
      }
    );
  };

  hideModalObavijest = () => {
    console.log(this.state);
    this.setState({
      obavijestModal: false,
      obavijesti: [],
      unosObavijestiData: {
        napomena: "",
        selectedFiles: [],
        absenceStart:"",
        absenceEnd:"",
      },
      error: false,
      datPocStrUsv:null,
      datZavStrUsv: null,
    });
  };

  openModalBrisanje = (e, rbr, idStrUsv, vrAktivnosti) => {
    e.preventDefault();
    this.setState({
      rbr: rbr,
      idStrUsv: idStrUsv,
      vrstaAktivnosti: vrAktivnosti,
      brisanjeEdukacijeModal: true,
    });
  };

  hideModalBrisanje = () => {
    this.setState({
      brisanjeEdukacijeModal: false,
    });
  };

  /***************** HANDLERI ******************/
  dropdownOznAktHandler = (e) => {
    e.persist();
    const vrAktivnosti = e.target.value;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        vrAktivnosti,
      },
      vrstaAktivnosti: vrAktivnosti,
    }));
  };

  dropdownUlSudHandler = (e) => {
    e.persist();
    const oznPolEdu = e.target.value;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        oznPolEdu,
      },
    }));
  };

  userInputHandler = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [id]: value,
      },
    }));
  };

  userInputHandlerNum = ({ target: { id, value } }) => {
    if (value > 9999) {
      return;
    }

    //let replacedValue = (id.includes("Bodovi") || id.includes("bodovi")) ? this.allowOnlyHalfPoints(this.replaceForDecimal(value)) : value.replace(/[^\d]/g, "");

    let replacedValue = this.allowOnlyHalfPoints(this.replaceForDecimal(value));

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [id]: replacedValue,
      },
    }));
  };

  replaceForDecimal = (value) => {
    let counter = 0;
    let validatedStr = value.replace(/[^0-9.]|\./g, function($0){
      if($0 == "." && !(counter++))
        return ".";
      return "";
    })
    return validatedStr;
  }

  allowOnlyHalfPoints = (value) =>{
    //funkcija koja osigurava unos samo broja 5 nakon točke
    let intVal = Math.trunc(value); 
    let decVal = Math.fround(value % 1);

    if(decVal >= 0.5){
      return intVal + 0.5;
    }
    if(value.includes(".")){
      return intVal + ".";
    }
    return intVal;

  }

  unosObavijestiInputHandler = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    this.setState((prevState) => ({
      unosObavijestiData: {
        ...prevState.unosObavijestiData,
        [id]: value,
      },
    }));
    if (value.length > 500) {
      this.props.formSubmitError(
        true,
        "Dosegli ste maksimalnu duljinu unosa znakova!"
      );
    }
  };

  unosObavijestiDatePickerHandler = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState((prevState) => ({
      unosObavijestiData:{
        ...prevState.unosObavijestiData,
        [objData.id]: selectedDate,
      }
    }))
  };

  uploadHandler = (e) => {
    let index = 0;
    let selectedFiles = Array.from(e.target.files).map((file) => {
      return {
        id: index++,
        file: file,
      };
    });

    if (selectedFiles.length === 0) {
      return;
    }
    for (let i = 0; i < selectedFiles.length; i++) {
      const isFileLt10MB =  selectedFiles[i].file.size / 1024 / 1024 < 10;
      if (selectedFiles[i].file.size && !isFileLt10MB) {
        this.props.formSubmitError(false, "Nije dopušteno učitavanje datoteka većih od 10MB.");
        return;
      }
    }
    this.setState((prevState) => ({
      unosObavijestiData: {
        ...prevState.unosObavijestiData,
        selectedFiles: selectedFiles,
      },
    }));
  };

  uploadObrazacHandler = (e) => {
    let selectedFiles = {
      id: e.target.id,
      file: null,
    };

    selectedFiles.file = e.target.files[0];
    if (selectedFiles.file === undefined) {
      return;
    }

    const isFileLt10MB =  selectedFiles.file.size / 1024 / 1024 < 10;
    if ( selectedFiles.file.size && !isFileLt10MB) {
      this.props.formSubmitError(false, "Nije dopušteno učitavanje datoteka većih od 10MB.");
      return;
    }

    let setSelectedFiles = [...this.state.obrazacData.selectedFile];
    setSelectedFiles = [];
    setSelectedFiles.push(selectedFiles);
    this.setState((prevState) => ({
      obrazacData: {
        ...prevState.obrazacData,
        selectedFile: setSelectedFiles,
      },
    }));
  };

  setError = (message) => {
    this.setState({error: true}, () => this.props.formSubmitError(true, message));
  }

  obavijestSubmitHandler = async (e) => {
    e.preventDefault();

    const idStrUsv = this.state.idStrUsv;
    const napomena = this.state.unosObavijestiData.napomena;
    const dokumenti = this.state.unosObavijestiData.selectedFiles;
    const absenceStart = this.state.unosObavijestiData.absenceStart;
    const absenceEnd = this.state.unosObavijestiData.absenceEnd;

    if(!absenceStart){
      this.setError("Datum početka je obavezan!");
      return;
    }
    if(!absenceEnd){
      this.setError("Datum završetka je obavezan!");
      return;
    }
    
    if(dokumenti.length <= 0){
      this.setError("Potrebno je učitati obavijest!");
      return;
    }
    if (this.state.unosObavijestiData.napomena.length > 500) {
        this.setError("Duljina napomene mora biti manja od 500 znakova!");
        return;
    }
    try {
      const formData = new FormData();
      dokumenti.forEach(item => {
        formData.append('obavijesti', item.file);
      });
      formData.append("idStrUsv", idStrUsv);
      formData.append("napomena", napomena);
      formData.append("absenceStart", moment(absenceStart, "DD.MM.YYYY"));
      formData.append("absenceEnd", moment(absenceEnd, "DD.MM.YYYY"));

      await axiosInstance.post("/strucno-usavrsavanje/upload/obavijest", formData);
    } catch (e) {
      this.props.formSubmitError(true, e.response.data.message || "Nešto je pošlo po krivu!");
    }
    this.props.formSubmitSuccess(false, "Uspješno spremljeno");
    this.setState({
      unosObavijestiData: {
        napomena: "",
        selectedFiles: [],
        absenceStart: "",
        absenceEnd: "",
      }
    }, () => {this.hideModalObavijest();});
  };

  deleteObavijestHandler = async (docID) => {
    this.setState({isListLoading: true});
    try{
      const res = await axiosInstance.delete(`/strucno-usavrsavanje/obavijest?docID=${docID}`);
      if(res.data === docID){
        const temp = this.state.obavijesti.filter(ob => !ob.dokumenti.some(val => val.dokumentId === docID));
        this.setState({obavijesti: temp});
      }
    }catch(e){
      toast.info(e.response.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    this.setState({isListLoading:false});
  }

  approveObavijestHandler = async (docID) => {
    this.setState({isListLoading: true});
    try{
      const res = await axiosInstance.post(`/strucno-usavrsavanje/obavijest/approve?docID=${docID}`);
        const temp = this.state.obavijesti.filter(ob => !ob.dokumenti.some(val => val.dokumentId === docID));
        this.setState({obavijesti: temp});
    }catch(e){
      toast.info(e.response.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    this.setState({isListLoading:false});
  }

  disableObavijestHandler = async (docID) => {
    this.setState({isListLoading: true});
    try{
      const res = await axiosInstance.post(`/strucno-usavrsavanje/obavijest/disable?docID=${docID}`);
        const temp = this.state.obavijesti.filter(ob => !ob.dokumenti.some(val => val.dokumentId === docID));
        this.setState({obavijesti: temp});
    }catch(e){
      toast.info(e.response.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    this.setState({isListLoading:false});
  }

  datePickerHandler = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        [objData.id]: selectedDate,
      },
    });
  };

  async getObavijesti(idStrUsv) {
    this.setState({isListLoading: true});
    try {
      const res = await axiosInstance.get(`/strucno-usavrsavanje/obavijest?idStrUsv=${idStrUsv}`)
      this.setState({obavijesti: res.data});
    } catch (error) {
      throw error;
    }
    this.setState({isListLoading: false});
  }

  getObrazac = async (e, susvAnalitika) => {
    e.persist();

    await axiosInstance
      .get(
        `/strucno-usavrsavanje/obrazac?idStrUsv=${susvAnalitika.idStrUsv}&rbr=${susvAnalitika.rbr}`
      )
      .then((res) => {
        if (res.data) {
          let selectedFiles = {
            id: "obrazac",
            file: res.data,
          };

          let setSelectedFiles = [...this.state.obrazacData.selectedFile];
          setSelectedFiles = [];
          setSelectedFiles.push(selectedFiles);
          this.setState((prevState) => ({
            obrazacData: {
              ...prevState.obrazacData,
              selectedFile: setSelectedFiles,
            },
          }));
        }
      });

    this.openModalAzuriranje(e, susvAnalitika);
  };

  /***************** DOWNLOAD DOKUMENATA ******************/
  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  downloadObavijest = (e, idStrUsvDok) => {
    e.preventDefault();
    axiosInstance
      .get(
        `/strucno-usavrsavanje/obavijest/download?idStrUsvDok=${idStrUsvDok}`
      )
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([this.b64toBlob(res.data.blob)])
        );
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          idStrUsvDok +
            "_obavijest_o_nemogucnosti_izvrsavanja_obveza_SSU." +
            res.data.extension
        );
        document.body.appendChild(link);
        link.click();
      });
  };

  downloadObrazac = (e, idStrUsv, rbr) => {
    e.preventDefault();
    axiosInstance
      .get(
        `/strucno-usavrsavanje/obrazac/download?idStrUsv=${idStrUsv}&rbr=${rbr}`
      )
      .then((res) => {
        if (res.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(res.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idStrUsv +
              "-" +
              rbr +
              "_obrazac_evidencija_SSU." +
              res.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };

  /***************** ŠIFRARNICI ******************/
  getVrsteAktivnosti = async () => {
    await axiosInstance.get("/sifarnici/vrstaAktivnosti").then((res) => {
      this.setState({
        dropdownVrAkt: res.data,
      });
    });
  };

  getUlogeSudionika = async () => {
    await axiosInstance.get("/sifarnici/ulogaSudionika").then((res) => {
      this.setState({
        dropdownUlSudionika: res.data,
      });
    });
  };

  deleteSusvAnalitika = (event, rbr, idStrUsv, vrAktivnosti) => {
    event.preventDefault();
    try {
      axiosInstance.delete(
        `/strucno-usavrsavanje/analitika?rbr=${rbr}&idStrUsv=${idStrUsv}&vrAktivnosti=${vrAktivnosti}`
      );
      this.getRevizor();
      this.props.formSubmitSuccess(
        false,
        "Uspješno obrisano. Provjerite tablicu s izračunom sati i bodova."
      );
      this.setState({
        brisanjeEdukacijeModal: false,
      });
    } catch (error) {
      this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
    }
  };

  render() {
    const { isAuthenticated, userData } = this.props;

    const userRole = userData != null ? userData.roles[0].roleName : null;
    const checkIfUserIsAdmin =
      userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

    return (
      <>
        {this.state.isListLoading ? (
          <Container className="dataLoader">
            <Row style={{ justifyContent: "center" }}>
              <Col style={{ alignItems: "center" }}>
                <Spinner
                  animation="border"
                  variant="secondary"
                  style={{ marginTop: "16px", marginBottom: "16px" }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  style={{ marginTop: "16px", marginLeft: "16px" }}
                  className="spin-text"
                >
                  <b>Učitavam...</b>
                </div>
              </Col>
            </Row>
          </Container>
        ) : null}
        {this.state.strucnaUsavrsavanja.map((strUsv, index1) => (
          <Container
            key={`pregled-strucnog-usavrsavanja-container${index1}`}
            fluid
            className={"strucno-card " + (strUsv.sts === 1 ? "green" : "red")}
          >
            <iframe
              sandbox=""
              id="ifmcontentstoprint"
              style={{
                height: "0px",
                width: "0px",
                position: "absolute",
                display: "none",
              }}
            ></iframe>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return (
                <div>
                    <ButtonComponent
                      variant="secondary"
                      icon={<PrinterOutlined />}
                      className="print-btn"
                    >
                      Ispis
                    </ButtonComponent>{" "}
                  </div>
                );
              }}
              content={() => this.componentRef[index1]}
            />
            </div>
            <div
              className="print-container"
              style={{ margin: "0", padding: "0" }}
              ref={(el) => (this.componentRef[index1] = el)}
            >
              <div className="page-break" />
              <div id="printArea">
                {strUsv.sts === 1 ? (
                  <Badge pill variant="success">
                    {moment(strUsv.datPoc).format("DD.MM.YYYY")}-
                    {strUsv.datZav
                      ? moment(strUsv.datZav).format("DD.MM.YYYY")
                      : moment(strUsv.datPoc).add(3, "years").calendar()}
                  </Badge>
                ) : (
                  <Badge pill variant="danger">
                    {moment(strUsv.datPoc).format("DD.MM.YYYY")}-
                    {strUsv.datZav
                      ? moment(strUsv.datZav).format("DD.MM.YYYY")
                      : moment(strUsv.datPoc).add(3, "years").calendar()}
                  </Badge>
                )}
                {strUsv.sekcijaObrasca.map((element, index2) => (
                  <div
                    key={`pregled-strucnog-usavrsavanja-key${index2}`}
                    className="strSpec"
                  >
                    <Table bordered hover responsive className="strUsvTable">
                      <caption>
                        <h5>
                          {element.vrAktivnosti === 1
                            ? "A - Specifikacija osnovnih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 1. točke 1. Pravilnika"
                            : element.vrAktivnosti === 2
                            ? "B - Specifikacija osnovnih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 1. točke 2. do 5. Pravilnika"
                            : "C - Specifikacija ostalih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 2. točke 1. i 2. Pravilnika"}
                        </h5>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Rb.</th>
                          <th scope="col">Dokument</th>
                          <th scope="col">Organizator</th>
                          <th scope="col">Naziv aktivnosti</th>
                          <th scope="col">Datum</th>
                          <th scope="col">Područje aktivnosti</th>
                          <th scope="col">Uloga sudionika</th>
                          <th scope="col">Ukupno sati aktivnosti</th>
                          <th scope="col">Ukupno ostvareni bodovi</th>
                          <th scope="col" className="edukacija-akcije">
                            Ažuriraj
                          </th>
                          <th scope="col" className="edukacija-akcije">
                            Obriši
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {element.susvAnalitikaList.length > 0 ? (
                          element.susvAnalitikaList.map(
                            (susvAnalitika, index) => (
                              <tr key={susvAnalitika.rbr}>
                                <td>{index + 1}.</td>
                                <td className="ikona_dokument_td">
                                  <ButtonComponent
                                    variant="secondary"
                                    className="ikona_dokument"
                                    onClick={(e) =>
                                      this.downloadObrazac(
                                        e,
                                        susvAnalitika.idStrUsv,
                                        susvAnalitika.rbr
                                      )
                                    }
                                  >
                                    <PaperClipOutlined />
                                  </ButtonComponent>
                                </td>
                                <td>{susvAnalitika.organizator}</td>
                                <td>{susvAnalitika.nazAktivnosti}</td>
                                <td className="datum">
                                  <Col>
                                    <b>od: </b>
                                    {susvAnalitika.datPoc}
                                  </Col>
                                  <Col>
                                    <b>do: </b>
                                    {susvAnalitika.datZav}
                                  </Col>
                                </td>
                                <td>{susvAnalitika.podrucje}</td>
                                <td>
                                  {susvAnalitika.oznPolEdu === 1
                                    ? "Edukator"
                                    : "Polaznik"}
                                </td>
                                <td>{susvAnalitika.brSati}</td>
                                <td>{susvAnalitika.brBodova}</td>
                                <td className="ant_batn edukacija-akcije">
                                  <ButtonComponent
                                    variant="secondary"
                                    disabled={
                                      (!checkIfUserIsAdmin && strUsv.sts !== 1) ||  (this.state.revizorAktivnost != 1)
                                    }
                                    onClick={(e) =>
                                      this.getObrazac(e, susvAnalitika)
                                    }
                                  >
                                    <EditOutlined />
                                  </ButtonComponent>
                                </td>
                                <td className="disableButton ant_batn edukacija-akcije">
                                  <ButtonComponent
                                    variant="secondary"
                                    disabled={
                                      (!checkIfUserIsAdmin && strUsv.sts !== 1) ||  (this.state.revizorAktivnost != 1)
                                    }
                                    onClick={(e) =>
                                      this.openModalBrisanje(
                                        e,
                                        susvAnalitika.rbr,
                                        susvAnalitika.idStrUsv,
                                        susvAnalitika.vrAktivnosti
                                      )
                                    }
                                  >
                                    <DeleteOutlined />
                                  </ButtonComponent>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="12">
                              <i>
                                Nema unesenih podataka o stručnom usavršavanju
                                revizora.
                              </i>
                            </td>
                          </tr>
                        )}
                        {element.susvAnalitikaList.length > 0 ? (
                          <>
                            <tr>
                              <td colSpan="4" className="hiddenTd"></td>
                              <th
                                className="line-top"
                                style={{ textAlign: "left" }}
                                colSpan="3"
                              >
                                Ukupno revizijska područja
                              </th>
                              <td className="line-top">
                                {element.susvSintetika.revSati}
                              </td>
                              <td className="line-top">
                                {element.susvSintetika.revBodovi}
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="4" className="hiddenTd"></td>
                              <th colSpan="3" style={{ textAlign: "left" }}>
                                Ukupno računovodstvena područja
                              </th>
                              <td>{element.susvSintetika.racSati}</td>
                              <td>{element.susvSintetika.racBodovi}</td>
                            </tr>
                            <tr>
                              <td colSpan="4" className="hiddenTd"></td>
                              <th colSpan="3" style={{ textAlign: "left" }}>
                                Ukupno ostala područja
                              </th>
                              <td>{element.susvSintetika.ostSati}</td>
                              <td>{element.susvSintetika.ostBodovi}</td>
                            </tr>
                            <tr>
                              <td colSpan="4" className="hiddenTd"></td>
                              <th colSpan="3" style={{ textAlign: "left" }}>
                                Ukupno područja A
                              </th>
                              <td>{element.susvSintetika.ukSatiPodrucjeA}</td>
                              <td>{element.susvSintetika.ukBodoviPodrucjeA}</td>
                            </tr>

                            <tr>
                              <td colSpan="4" className="hiddenTd"></td>
                              <th
                                colSpan="3"
                                className="line-top"
                                style={{ textAlign: "left" }}
                              >
                                Sveukupno
                              </th>
                              <td className="line-top">
                                {element.susvSintetika.ukSati}
                              </td>
                              <td className="line-top">
                                {element.susvSintetika.ukBodovi}
                              </td>
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    </Table>
                    <Row>
                      {checkIfUserIsAdmin || strUsv.sts === 1 ? (
                        <Col md={{ span: 6, offset: 6 }}>
                          <ButtonComponent
                            className="dodaj-novo"
                            onClick={(e) => {
                              this.openModalDodavanje(
                                e,
                                element.vrAktivnosti,
                                element.susvSintetika.idStrUsv,
                                strUsv.datPoc,
                                strUsv.datZav
                              );
                            }}
                            disabled={this.state.revizorAktivnost != 1}
                          >
                            Unos edukacije
                          </ButtonComponent>
                        </Col>
                      ) : null}
                    </Row>
                  </div>
                ))}
                <Row>
                  <Col md={{ span: 6, offset: 6 }} sm={{ span: 12 }}>
                    <Table
                      bordered
                      className="strUsvTable"
                      style={{ margin: "16px 0" }}
                    >
                      <tbody>
                        <tr>
                          <th>Sveukupno sati:</th>
                          <td>{strUsv.sveukupnoSati}</td>
                        </tr>
                        <tr>
                          <th>Sveukupno bodova: </th>
                          <td>{strUsv.sveukupnoBodova}</td>
                        </tr>
                        <tr>
                          <ObligationDetails idStrUsv={strUsv.idStrUsv} personId={strUsv.idOsobe}/>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            </div>
            <br></br>
            <Row>
              {strUsv.sts === 1 ? (
                <Col md={{ span: 6, offset: 6 }}>
                  <ButtonComponent
                    className="obavijest"
                    variant="outline-info"
                    onClick={(e) => {
                      this.openModalObavijest(e, strUsv.idStrUsv, strUsv.datPoc, strUsv.datZav);
                    }}
                  >
                    Obavijest o nemogućnosti ispunjenja obveze
                  </ButtonComponent>
                </Col>
              ) : null}
            </Row>
          </Container>
        ))}

        <UnosObavijesti
          {...this.state}
          hideModalObavijest={this.hideModalObavijest}
          uploadHandler={this.uploadHandler}
          obavijestSubmitHandler={this.obavijestSubmitHandler}
          unosObavijestiInputHandler={this.unosObavijestiInputHandler}
          downloadObavijest={this.downloadObavijest}
          datePickerHandler={this.unosObavijestiDatePickerHandler}
          deleteObavijestHandler={this.deleteObavijestHandler}
          approveObavijestHandler={this.approveObavijestHandler}
          disableObavijestHandler={this.disableObavijestHandler}
          userRole={userRole}
        ></UnosObavijesti>

        <DodajStrucnoUsavrsavanje
          {...this.state}
          hideModalDodavanje={this.hideModalDodavanje}
          submitHandler={this.submitHandler}
          isLoading={this.state.isLoading}
          dropdownOznAktHandler={this.dropdownOznAktHandler}
          dropdownUlSudHandler={this.dropdownUlSudHandler}
          userInputHandler={this.userInputHandler}
          userInputHandlerNum={this.userInputHandlerNum}
          datePickerHandler={this.datePickerHandler}
          userUpdateInputHandler={this.userUpdateInputHandler}
          getVrsteAktivnosti={this.getVrsteAktivnosti}
          getUlogeSudionika={this.getUlogeSudionika}
          uploadObrazacHandler={this.uploadObrazacHandler}
          downloadObrazac={this.downloadObrazac}
        ></DodajStrucnoUsavrsavanje>

        <Modal
          show={this.state.brisanjeEdukacijeModal}
          onHide={(e) => this.hideModalBrisanje()}
          size="md"
          centered
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Fragment>
            <Container>
              <Row>
                <Col>
                  {" "}
                  Jeste li sigurni da želite obrisati stručno usavršavanje?
                </Col>
                <Fragment>
                  <ButtonComponent
                    variant="primary"
                    onClick={(e) =>
                      this.deleteSusvAnalitika(
                        e,
                        this.state.rbr,
                        this.state.idStrUsv,
                        this.state.vrstaAktivnosti
                      )
                    }
                    style={{ marginRight: "4px" }}
                  >
                    Da
                  </ButtonComponent>
                  <ButtonComponent
                    variant="danger"
                    onClick={(e) => this.hideModalBrisanje()}
                  >
                    Ne
                  </ButtonComponent>
                </Fragment>
              </Row>
              <Row style={{ marginTop: "16px" }}></Row>
            </Container>
          </Fragment>
        </Modal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state.authentication.userData,
    isAuthenticated: state.authentication.isAuthenticated,
    visionImpaired: state.layout.visionImpaired,
    fontSize: state.layout.fontSize,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PregledStrucnogUsavrsavanja);
